// import { ThemeEvents } from '@theme/events';
// import { debounce } from '@theme/utilities';

// class ProductFormMnm extends HTMLElement {
//   #debouncedQuantityChange = debounce(this.#onQuantityChange, 100).bind(this);

//   connectedCallback() {
//     // --- Image slider (unchanged) ---
//     this.slider = this.querySelector('.mnm-card__slider');
//     this.slides = Array.from(this.querySelectorAll('.mnm-card__slide'));
//     this.dots = Array.from(this.querySelectorAll('.mnm-card__dot'));
//     this.currentIndex = 0;
//     this.dots.forEach((dot) => {
//       dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dotIndex, 10)));
//     });
//     if (this.slider) {
//       this.slider.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
//     }
//     this.querySelector('[data-arrow-prev]')?.addEventListener('click', () => {
//       this.goTo(Math.max(0, this.currentIndex - 1));
//     });
//     this.querySelector('[data-arrow-next]')?.addEventListener('click', () => {
//       this.goTo(Math.min(this.slides.length - 1, this.currentIndex + 1));
//     });

//     // --- Add to cart -> quantity stepper ---
//     // this.cartControl = this.querySelector('.mnm-card__cartcontrol');
//     // this.addBtn = this.querySelector('[data-add-btn]');
//     // this.stepper = this.querySelector('[data-stepper]');
//     this.cartControl = this.querySelector('.mnm-card__cartcontrol');
//   this.addBtn = this.querySelector('[data-add-btn]');
//   this.stepper = this.querySelector('[data-stepper]');

//   // Capture the true label once, so it never gets stuck on a transient state
//   this.addBtnLabel = this.addBtn?.textContent.trim();

//   this.addBtn?.addEventListener('click', () => this.handleAdd());
//   this.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedQuantityChange);

//     // this.addBtn?.addEventListener('click', () => this.handleAdd());

//     // // Same event component-cart-items.js listens for on cart line rows —
//     // // here we handle it directly since this card isn't inside a cart-items-component.
//     // this.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedQuantityChange);
//   }

//   disconnectedCallback() {
//     this.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedQuantityChange);
//   }

//   /**
//    * @param {CustomEvent} event
//    */
//   #onQuantityChange(event) {
//     if (!(event.target instanceof Node) || !this.contains(event.target)) return;

//     const { quantity } = event.detail;

//     if (quantity === 0) {
//       this.handleRemove();
//       return;
//     }

//     this.handleUpdate(quantity);
//   }

//   async handleAdd() {
//     if (!this.addBtn || !this.cartControl) return;
//     const variantId = this.cartControl.dataset.variantId;
//     const originalText = this.addBtn.textContent;

//     this.addBtn.disabled = true;
//     this.addBtn.textContent = 'Adding…';

//     try {
//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       });
//       if (!res.ok) throw new Error('Add to cart failed');

//       this.showStepper();
//       this.notifyCartUpdate(variantId);
//     } catch (err) {
//       this.addBtn.disabled = false;
//       this.addBtn.textContent = originalText;
//       console.error('[product-card-v2] add to cart failed:', err);
//     }
//   }

//   async handleUpdate(quantity) {
//     if (!this.cartControl) return;
//     const variantId = this.cartControl.dataset.variantId;

//     this.cartControl.classList.add('mnm-card__cartcontrol--updating');

//     try {
//       const res = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity })
//       });
//       if (!res.ok) throw new Error('Update quantity failed');

//       this.notifyCartUpdate(variantId);
//     } catch (err) {
//       console.error('[product-card-v2] update quantity failed:', err);
//     } finally {
//       this.cartControl.classList.remove('mnm-card__cartcontrol--updating');
//     }
//   }

//   async handleRemove() {
//     if (!this.cartControl) return;
//     const variantId = this.cartControl.dataset.variantId;

//     this.cartControl.classList.add('mnm-card__cartcontrol--updating');

//     try {
//       const res = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 0 })
//       });
//       if (!res.ok) throw new Error('Remove from cart failed');

//       this.showAddButton();
//       this.notifyCartUpdate(variantId);
//     } catch (err) {
//       console.error('[product-card-v2] remove from cart failed:', err);
//     } finally {
//       this.cartControl.classList.remove('mnm-card__cartcontrol--updating');
//     }
//   }

//   // showStepper() {
//   //   if (!this.addBtn || !this.stepper) return;
//   //   this.addBtn.hidden = true;
//   //   this.stepper.hidden = false;
//   // }

//   // showAddButton() {
//   //   if (!this.addBtn || !this.stepper) return;
//   //   this.stepper.hidden = true;
//   //   this.addBtn.hidden = false;
//   //   this.addBtn.disabled = false;
//   // }

// //   syncStepperQuantity(quantity) {
// //   if (!this.stepper) return;
// //   const input = this.stepper.querySelector('input[data-cart-quantity]');
// //   if (input) {
// //     input.value = String(quantity);
// //     input.setAttribute('data-cart-quantity', String(quantity));
// //   }
// //   const selectorEl = this.stepper.querySelector('quantity-selector-component');
// //   if (selectorEl?.updateCartQuantity) selectorEl.updateCartQuantity();
// //   if (selectorEl?.updateButtonStates) selectorEl.updateButtonStates();
// // }


// syncStepperQuantity(quantity) {
//   if (!this.stepper) return;

//   const input = this.stepper.querySelector('input[data-cart-quantity]');
//   if (input) {
//     // Ensure we don't display 0 inside an active stepper unless intended
//     const displayQty = Number(quantity) > 0 ? quantity : 1;
//     input.value = String(displayQty);
//     input.setAttribute('data-cart-quantity', String(displayQty));
//   }

//   const selectorEl = this.stepper.querySelector('quantity-selector-component');
//   if (selectorEl?.updateCartQuantity) selectorEl.updateCartQuantity();
//   if (selectorEl?.updateButtonStates) selectorEl.updateButtonStates();
// }

// //   showStepper() {
// //   if (!this.addBtn || !this.stepper) return;
// //   this.addBtn.hidden = true;
// //   this.stepper.hidden = false;
// // }

// showStepper() {
//   if (!this.addBtn || !this.stepper) return;
  
//   this.addBtn.hidden = true;
//   this.stepper.hidden = false;

//   // Check current input value; if it's 0 (or empty), initialize it to 1 on first reveal
//   const input = this.stepper.querySelector('input[data-cart-quantity]');
//   if (input && (parseInt(input.value, 10) === 0 || !input.value)) {
//     this.syncStepperQuantity(1);
//   }
// }

// showAddButton() {
//   if (!this.addBtn || !this.stepper) return;
//   this.stepper.hidden = true;
//   this.addBtn.hidden = false;
//   this.addBtn.disabled = false;
//   this.addBtn.textContent = this.addBtnLabel;
// }

//   async notifyCartUpdate(variantId) {
//     try {
//       const res = await fetch('/cart.js');
//       const cart = await res.json();
//       document.dispatchEvent(new CustomEvent('cart:update', {
//         bubbles: true,
//         detail: {
//           resource: cart,
//           sourceId: this.dataset.blockId || 'mnm-card-v2',
//           data: {
//             source: 'mnm-card-v2',
//             itemCount: cart.item_count,
//             variantId
//           }
//         }
//       }));
//     } catch (err) {
//       console.error('[product-card-v2] failed to refresh cart count:', err);
//     }
//   }

//   goTo(index) {
//     this.currentIndex = index;
//     const slide = this.slides[index];
//     if (slide && this.slider) {
//       this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
//     }
//   }

//   syncFromScroll() {
//     if (!this.slider) return;
//     const scrollLeft = this.slider.scrollLeft;
//     let closest = 0;
//     let closestDist = Infinity;
//     this.slides.forEach((slide, i) => {
//       const dist = Math.abs(slide.offsetLeft - scrollLeft);
//       if (dist < closestDist) { closestDist = dist; closest = i; }
//     });
//     this.currentIndex = closest;
//     this.slides.forEach((s, i) => s.classList.toggle('is-active', i === closest));
//     this.dots.forEach((d, i) => {
//       d.classList.toggle('is-active', i === closest);
//       d.setAttribute('aria-selected', String(i === closest));
//     });
//   }
// }

// if (!customElements.get('product-form-mnm')) {
//   customElements.define('product-form-mnm', ProductFormMnm);
// }




import { ThemeEvents } from '@theme/events';
import { debounce } from '@theme/utilities';

class ProductFormMnm extends HTMLElement {
  #debouncedQuantityChange = debounce(this.#onQuantityChange, 100).bind(this);

  connectedCallback() {
    // ------------------------------------------------------------
    // Image slider
    // ------------------------------------------------------------
    this.slider = this.querySelector('.mnm-card__slider');
    this.slides = Array.from(this.querySelectorAll('.mnm-card__slide'));
    this.dots = Array.from(this.querySelectorAll('.mnm-card__dot'));
    this.currentIndex = 0;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.dotIndex, 10));
      });
    });

    if (this.slider) {
      this.slider.addEventListener('scroll', () => this.syncFromScroll(), {
        passive: true,
      });
    }

    this.querySelector('[data-arrow-prev]')?.addEventListener('click', () => {
      this.goTo(Math.max(0, this.currentIndex - 1));
    });

    this.querySelector('[data-arrow-next]')?.addEventListener('click', () => {
      this.goTo(
        Math.min(this.slides.length - 1, this.currentIndex + 1)
      );
    });

    // ------------------------------------------------------------
    // Cart / quantity controls
    // ------------------------------------------------------------
    this.cartControl = this.querySelector('.mnm-card__cartcontrol');
    this.addBtn = this.querySelector('[data-add-btn]');
    this.stepper = this.querySelector('[data-stepper]');

    // Capture the real button label once.
    // This prevents "Adding..." or another temporary state from
    // becoming the permanent button label.
    this.addBtnLabel = this.addBtn?.textContent.trim() || '';

    // Track the quantity currently represented by this card.
    this.cartQty =
      Number(
        this.stepper?.querySelector('input[data-cart-quantity]')?.value
      ) || 0;

    this.addBtn?.addEventListener('click', () => this.handleAdd());

    this.addEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this.#debouncedQuantityChange
    );
  }

  disconnectedCallback() {
    this.removeEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this.#debouncedQuantityChange
    );
  }

  /**
   * Animate the current product image towards the cart icon.
   *
   * @param {HTMLElement} sourceEl
   */
  #animateFlyToCart(sourceEl) {
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const image = this.slides[this.currentIndex]?.querySelector('img');

    if (!cartIcon || !sourceEl || !image) return;

    const flyToCartElement = document.createElement('fly-to-cart');

    flyToCartElement.classList.add('fly-to-cart--quick');

    flyToCartElement.style.setProperty(
      'background-image',
      `url(${image.currentSrc || image.src})`
    );

    flyToCartElement.style.setProperty('--start-opacity', '0');

    flyToCartElement.source = sourceEl;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  }

  /**
   * Handle quantity selector changes.
   *
   * @param {CustomEvent} event
   */
  // #onQuantityChange(event) {
  //   if (!(event.target instanceof Node) || !this.contains(event.target)) {
  //     return;
  //   }

  //   const { quantity } = event.detail;
  //   const newQuantity = Number(quantity) || 0;

  //   // Removing the item.
  //   if (newQuantity === 0) {
  //     this.cartQty = 0;
  //     this.handleRemove();
  //     return;
  //   }

  //   // Only animate when quantity actually increases.
  //   if (newQuantity > this.cartQty) {
  //     const plusBtn =
  //       this.stepper?.querySelector('[data-quantity-increase]') ||
  //       this.stepper;

  //     this.#animateFlyToCart(plusBtn);
  //   }

  //   // Keep our local tracker synchronized.
  //   this.cartQty = newQuantity;

  //   this.handleUpdate(newQuantity);
  // }

  #onQuantityChange(event) {
  if (!(event.target instanceof Node) || !this.contains(event.target)) return;

  const { quantity } = event.detail;

  if (quantity === 0) {
    this.handleRemove();
    return;
  }

  if (quantity > this.cartQty) {
    const plusBtn = this.stepper?.querySelector('[data-quantity-increase]') || this.stepper;
    this.#animateFlyToCart(plusBtn);
  }

  this.handleUpdate(quantity);
}



  /**
   * Add the product to cart.
   */
  // async handleAdd() {
  //   if (!this.addBtn || !this.cartControl) return;

  //   const variantId = this.cartControl.dataset.variantId;

  //   if (!variantId) {
  //     console.error('[product-card-v2] missing variant ID');
  //     return;
  //   }

  //   const originalText = this.addBtn.textContent;

  //   this.addBtn.disabled = true;
  //   this.addBtn.textContent = 'Adding…';

  //   try {
  //     const res = await fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //       },
  //       body: JSON.stringify({
  //         id: variantId,
  //         quantity: 1,
  //       }),
  //     });

  //     if (!res.ok) {
  //       throw new Error('Add to cart failed');
  //     }

  //     // Show the quantity selector first.
  //     this.showStepper();

  //     // Animate the product image to the cart.
  //     this.#animateFlyToCart(this.addBtn);

  //     // The product now has one item in the cart.
  //     this.cartQty = 1;

  //     // Refresh cart state.
  //     this.notifyCartUpdate(variantId);
  //   } catch (err) {
  //     this.addBtn.disabled = false;
  //     this.addBtn.textContent = originalText;

  //     console.error('[product-card-v2] add to cart failed:', err);
  //   }
  // }

  async handleAdd() {
  if (!this.addBtn || !this.cartControl) return;
  const variantId = this.cartControl.dataset.variantId;
  const originalText = this.addBtn.textContent;

  // Fire immediately, while addBtn still has a real layout rect
  this.#animateFlyToCart(this.addBtn);

  this.addBtn.disabled = true;
  this.addBtn.textContent = 'Adding…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Add to cart failed');

    this.showStepper();
    this.cartQty = 1;
    this.notifyCartUpdate(variantId);
  } catch (err) {
    this.addBtn.disabled = false;
    this.addBtn.textContent = originalText;
    console.error('[product-card-v2] add to cart failed:', err);
  }
}

  /**
   * Update cart quantity.
   *
   * @param {number} quantity
   */
  // async handleUpdate(quantity) {
  //   if (!this.cartControl) return;

  //   const variantId = this.cartControl.dataset.variantId;

  //   if (!variantId) {
  //     console.error('[product-card-v2] missing variant ID');
  //     return;
  //   }

  //   this.cartControl.classList.add(
  //     'mnm-card__cartcontrol--updating'
  //   );

  //   try {
  //     const res = await fetch('/cart/change.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //       },
  //       body: JSON.stringify({
  //         id: variantId,
  //         quantity,
  //       }),
  //     });

  //     if (!res.ok) {
  //       throw new Error('Update quantity failed');
  //     }

  //     this.notifyCartUpdate(variantId);
  //   } catch (err) {
  //     console.error(
  //       '[product-card-v2] update quantity failed:',
  //       err
  //     );
  //   } finally {
  //     this.cartControl.classList.remove(
  //       'mnm-card__cartcontrol--updating'
  //     );
  //   }
  // }


async handleUpdate(quantity) {
  if (!this.cartControl) return;
  const variantId = this.cartControl.dataset.variantId;
  const previousQty = this.cartQty; // last known-good value

  this.cartControl.classList.add('mnm-card__cartcontrol--updating');

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Update quantity failed');

    this.cartQty = quantity; // confirm only after success
    this.notifyCartUpdate(variantId);
  } catch (err) {
    console.error('[product-card-v2] update quantity failed:', err);
    this.cartQty = previousQty;
    this.syncStepperQuantity(previousQty); // revert the visible input
  } finally {
    this.cartControl.classList.remove('mnm-card__cartcontrol--updating');
  }
}


  /**
   * Remove the product from cart.
   */
  // async handleRemove() {
  //   if (!this.cartControl) return;

  //   const variantId = this.cartControl.dataset.variantId;

  //   if (!variantId) {
  //     console.error('[product-card-v2] missing variant ID');
  //     return;
  //   }

  //   this.cartControl.classList.add(
  //     'mnm-card__cartcontrol--updating'
  //   );

  //   try {
  //     const res = await fetch('/cart/change.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //       },
  //       body: JSON.stringify({
  //         id: variantId,
  //         quantity: 0,
  //       }),
  //     });

  //     if (!res.ok) {
  //       throw new Error('Remove from cart failed');
  //     }

  //     this.showAddButton();
  //     this.notifyCartUpdate(variantId);
  //   } catch (err) {
  //     console.error(
  //       '[product-card-v2] remove from cart failed:',
  //       err
  //     );
  //   } finally {
  //     this.cartControl.classList.remove(
  //       'mnm-card__cartcontrol--updating'
  //     );
  //   }
  // }

  async handleRemove() {
  if (!this.cartControl) return;
  const variantId = this.cartControl.dataset.variantId;
  const previousQty = this.cartQty;

  this.cartControl.classList.add('mnm-card__cartcontrol--updating');

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    });
    if (!res.ok) throw new Error('Remove from cart failed');

    this.cartQty = 0;
    this.showAddButton();
    this.notifyCartUpdate(variantId);
  } catch (err) {
    console.error('[product-card-v2] remove from cart failed:', err);
    this.cartQty = previousQty;
    this.syncStepperQuantity(previousQty); 
  } finally {
    this.cartControl.classList.remove('mnm-card__cartcontrol--updating');
  }
}

  /**
   * Synchronize the visible stepper quantity.
   *
   * @param {number} quantity
   */
  syncStepperQuantity(quantity) {
    if (!this.stepper) return;

    const input = this.stepper.querySelector(
      'input[data-cart-quantity]'
    );

    if (input) {
      const displayQty = Number(quantity) > 0 ? quantity : 1;

      input.value = String(displayQty);
      input.setAttribute(
        'data-cart-quantity',
        String(displayQty)
      );
    }

    const selectorEl = this.stepper.querySelector(
      'quantity-selector-component'
    );

    selectorEl?.updateCartQuantity?.();
    selectorEl?.updateButtonStates?.();
  }

  /**
   * Show quantity selector after adding to cart.
   */
  showStepper() {
    if (!this.addBtn || !this.stepper) return;

    this.addBtn.hidden = true;
    this.stepper.hidden = false;

    const input = this.stepper.querySelector(
      'input[data-cart-quantity]'
    );

    if (
      input &&
      (!input.value || parseInt(input.value, 10) === 0)
    ) {
      this.syncStepperQuantity(1);
    }
  }

  /**
   * Show Add to Cart button after removing the item.
   */
  showAddButton() {
    if (!this.addBtn || !this.stepper) return;

    this.stepper.hidden = true;
    this.addBtn.hidden = false;
    this.addBtn.disabled = false;
    this.addBtn.textContent = this.addBtnLabel;
  }

  /**
   * Refresh cart data and notify the theme.
   *
   * @param {string} variantId
   */
  async notifyCartUpdate(variantId) {
    try {
      const res = await fetch('/cart.js');

      if (!res.ok) {
        throw new Error('Cart refresh failed');
      }

      const cart = await res.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId:
              this.dataset.blockId || 'mnm-card-v2',
            data: {
              source: 'mnm-card-v2',
              itemCount: cart.item_count,
              variantId,
            },
          },
        })
      );
    } catch (err) {
      console.error(
        '[product-card-v2] failed to refresh cart count:',
        err
      );
    }
  }

  /**
   * Navigate image slider to a specific slide.
   *
   * @param {number} index
   */
  goTo(index) {
    this.currentIndex = index;

    const slide = this.slides[index];

    if (slide && this.slider) {
      this.slider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth',
      });
    }
  }

  /**
   * Sync slider state from scroll position.
   */
  syncFromScroll() {
    if (!this.slider) return;

    const scrollLeft = this.slider.scrollLeft;

    let closest = 0;
    let closestDist = Infinity;

    this.slides.forEach((slide, i) => {
      const dist = Math.abs(slide.offsetLeft - scrollLeft);

      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });

    this.currentIndex = closest;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === closest);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === closest);
      dot.setAttribute(
        'aria-selected',
        String(i === closest)
      );
    });
  }
}

if (!customElements.get('product-form-mnm')) {
  customElements.define(
    'product-form-mnm',
    ProductFormMnm
  );
}